import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MarcasServices} from '../../services/marcas.services';
import {CategoriaMarcaModel, MarcaModel} from '../../models/marca.model';
import {Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';

@Component({
  selector: 'list-marcas',
  templateUrl: '../../templates/marcas/list.marcas.template.html'
})
export class MarcasCrudComponent implements OnInit, OnDestroy {

  public lstCatMarc: any[] = [];

  lstSubscriptions: Subscription[] = [];

  public catMarcSelect:CategoriaMarcaModel;

  @ViewChild("eliminarMarcCat",{static:false})
  template:TemplateRef<any>;

  modalRef:BsModalRef;

  constructor(private ms: MarcasServices, private spinner: NgxSpinnerService, private mods:BsModalService) {
  }

  ngOnInit(): void {
    this.ms.getCategoriasMarcas();
    this.spinner.show();
    this.lstSubscriptions.push(
      this.ms.obsGetCategoriasMarcas.subscribe((d: any) => {
        console.log(d);
        d.map((c: any) => {

          let marcas = '';

          c.marcas.map(m => {
            marcas += m.nombre + ', ';
          });

          this.lstCatMarc.push({
            idDB: c.idDB,
            _id: c._id,
            nombre: c.nombre,
            marcas: marcas.slice(0, -2)
          });
        });
        // this.lstCatMarc = d;
        this.spinner.hide();
      })
    );

    this.lstSubscriptions.push(
      this.ms.obsDeleteCategoriaMarcas.subscribe(d => {
        console.log(d);
        this.spinner.hide();
      })
    );
  }

  ngOnDestroy(): void {
    for (let subs of this.lstSubscriptions)
      subs.unsubscribe();
  }

  fireModalEliminar(c:CategoriaMarcaModel){
    this.catMarcSelect = c;
    this.modalRef = this.mods.show(this.template);

  }


  eliminarCategoria() {
    if(this.catMarcSelect) {
      this.spinner.show();
      this.ms.deleteCategoriaMarcas(this.catMarcSelect._id);
      this.lstCatMarc = this.lstCatMarc.filter(cm => cm._id != this.catMarcSelect._id);
      this.catMarcSelect = undefined;
      this.modalRef.hide();
    }
  }
}


@Component({
  selector: 'edit-marcas',
  templateUrl: '../../templates/marcas/edit.marcas.template.html'
})
export class EditMarcasComponent implements OnInit, OnDestroy {

  lstSubscriptions: Subscription[] = [];

  catMarca: CategoriaMarcaModel;
  lstMarcas: MarcaModel[] = [];
  lstMarcasSelect: MarcaModel[] = [];
  lstCategorias: any[] = [];

  selectListLstMarca: any;

  selectListMarcaCat: any;

  constructor(private ms: MarcasServices, private ar: ActivatedRoute, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {

    this.spinner.show();
    this.ms.getMarcas();
    this.ms.getCategoriasDB();


    this.lstSubscriptions.push(
      this.ms.obsGetCategoriaMarca.subscribe(d => {

        this.catMarca = d;
        this.spinner.hide();

        this.lstMarcasSelect = this.catMarca.marcas;

        this.lstMarcas = this.lstMarcas.filter(lsm => {
          let found = this.lstMarcasSelect.find(ms => ms.nombre == lsm.nombre);
          return !found;
        });

      })
    );

    this.lstSubscriptions.push(
      this.ms.obsGetCategoriasDB.subscribe(d => {

        this.lstCategorias = d;
        this.lstCategorias.map(c => c.nombre = c.nombre.trim());
      })
    );

    this.lstSubscriptions.push(
      this.ms.obsGetMarcas.subscribe(d => {
        this.lstMarcas = d;

        this.lstMarcas.map(m => m.nombre = m.nombre.trim());


        this.lstMarcas.sort((a: any, b: any) => {
          if (a.nombre > b.nombre)
            return 1;
          return -1;
        });

        let id = this.ar.snapshot.params.id;

        if (id) {
          this.ms.getCategoriaMarca(id);
        } else
          this.spinner.hide();
      })
    );

    this.lstSubscriptions.push(
      this.ms.obsSaveCategoriaMarcas.subscribe(d => {
        console.log(d);
        this.spinner.hide();
        alert('Categoria actualizada con exito');
      })
    );


  }

  guardarCatMarc() {
    if (this.catMarca) {
      this.catMarca.marcas = this.lstMarcasSelect;
      this.spinner.show();
      this.ms.saveCategoriaMarcas(this.catMarca);
    }
  }

  quitarMarca() {
    if (this.selectListMarcaCat) {
      this.lstMarcasSelect = this.lstMarcasSelect.filter(m => m.nombre != this.selectListMarcaCat.nombre);
      this.lstMarcas.push(this.selectListMarcaCat);
      this.lstMarcas.sort((a: any, b: any) => {
        if (a.nombre > b.nombre)
          return 1;
        return -1;
      });

      this.selectListMarcaCat = null;
    }

  }

  agregarMarca() {
    if (this.selectListLstMarca) {
      this.lstMarcas = this.lstMarcas.filter(m => m.nombre != this.selectListLstMarca.nombre);
      this.lstMarcasSelect.push(this.selectListLstMarca);
      this.lstMarcas.sort((a: any, b: any) => {
        if (a.nombre > b.nombre)
          return 1;
        return -1;
      });

      this.selectListLstMarca = null;
    }
  }


  changeCatMarca($event: any) {
    let val = $event.target.value;

    let cat = this.lstCategorias.find(c => c.nombre == val);

    if (cat) {
      this.catMarca.nombre = cat.nombre;
      this.catMarca.idDB = cat.idDB;
    }
  }

  ngOnDestroy(): void {
    for (let subs of this.lstSubscriptions)
      subs.unsubscribe();
  }
}

@Component({
  selector: 'new-marcas',
  templateUrl: '../../templates/marcas/new.marcas.template.html'
})
export class NewMarcasComponent implements OnInit, OnDestroy {

  lstSubscriptions: Subscription[] = [];

  catMarca: CategoriaMarcaModel = new CategoriaMarcaModel();
  lstMarcas: MarcaModel[] = [];
  lstMarcasSelect: MarcaModel[] = [];
  lstCategorias: any[] = [];

  selectListLstMarca: MarcaModel;

  selectListMarcaCat: MarcaModel;

  constructor(private ms: MarcasServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {

    this.spinner.show();
    this.ms.getMarcas();
    this.ms.getCategoriasDB();

    this.lstSubscriptions.push(
      this.ms.obsGetCategoriaMarca.subscribe(d => {
        console.log(d);
        this.catMarca = d;
        this.spinner.hide();

        this.lstMarcasSelect = this.catMarca.marcas;

        this.lstMarcas = this.lstMarcas.filter(lsm => {
          let found = this.lstMarcasSelect.find(ms => ms.nombre == lsm.nombre);
          return !found;
        });

      })
    );

    this.lstSubscriptions.push(
      this.ms.obsGetCategoriasDB.subscribe(d => {

        this.lstCategorias = d;
        this.lstCategorias.map(c => c.nombre = c.nombre.trim());

        this.catMarca.nombre = this.lstCategorias[0].nombre;
        this.catMarca.idDB = this.lstCategorias[0].idDB;
      })
    );

    this.lstSubscriptions.push(
      this.ms.obsGetMarcas.subscribe(d => {

        this.lstMarcas = d;

        this.lstMarcas.map(m => m.nombre = m.nombre.trim());

        this.lstMarcas.sort((a: any, b: any) => {
          if (a.nombre > b.nombre)
            return 1;
          return -1;
        });

        this.spinner.hide();
      })
    );

    this.lstSubscriptions.push(
      this.ms.obsSaveCategoriaMarcas.subscribe(d => {

        this.spinner.hide();
        alert('Categoria creada con exito');
      })
    );


  }

  guardarCatMarc() {

    this.catMarca.marcas = this.lstMarcasSelect;


    delete this.catMarca._id;
    this.spinner.show();
    this.ms.saveCategoriaMarcas(this.catMarca);
  }

  quitarMarca() {
    if (this.selectListMarcaCat) {
      this.lstMarcasSelect = this.lstMarcasSelect.filter(m => m.nombre != this.selectListMarcaCat.nombre);
      this.lstMarcas.push(this.selectListMarcaCat);
      this.lstMarcas.sort((a: any, b: any) => {
        if (a.nombre > b.nombre)
          return 1;
        return -1;
      });

      this.selectListMarcaCat = null;
    }

  }

  agregarMarca() {

    if (this.selectListLstMarca) {
      this.lstMarcas = this.lstMarcas.filter(m => m.nombre != this.selectListLstMarca.nombre);
      this.lstMarcasSelect.push(this.selectListLstMarca);
      this.lstMarcas.sort((a: any, b: any) => {
        if (a.nombre > b.nombre)
          return 1;
        return -1;
      });

      this.selectListLstMarca = null;
    }
  }


  changeCatMarca($event: any) {
    let val = $event.target.value;

    let cat = this.lstCategorias.find(c => c.nombre == val);

    if (cat) {
      this.catMarca.nombre = cat.nombre;
      this.catMarca.idDB = cat.idDB;
    }


  }

  ngOnDestroy(): void {
    for (let subs of this.lstSubscriptions)
      subs.unsubscribe();
  }
}
